// extracted by mini-css-extract-plugin
export default {"container":"BottomFooters_container__sO4fY","copyright":"BottomFooters_copyright__eCssZ","links":"BottomFooters_links__1Meh0","link":"BottomFooters_link__2Mabl"};